import { FC, ReactNode } from 'react';
import { BoxArrowInLeft, BoxArrowInRight, Lock } from 'react-bootstrap-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Card from 'react-bootstrap/Card';
import './styles/styles.css';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { GuestPackage } from '../../../modules/interfaces';

interface ReservationCardProps {
  title: string;
  content: ReactNode;
  type?: 'checkIn' | 'checkOut';
  active?: boolean;
  data?: GuestPackage[];
  checkOutFunction?: () => void;
}

function renderLockIcon(type: string) {
  if (type !== 'checkOut') {
    return (
      <Container className="checkin-unactive-container">
        <Lock style={{ margin: 'auto' }} size={27} className="icon" />
      </Container>
    );
  }
  return null;
}

export const CheckInCard: FC<ReservationCardProps> = ({
  title,
  content,
  type = 'checkIn',
  active = false,
  data,
  checkOutFunction,
}) => {
  const navigate = useNavigate();
  const { reservationId } = useParams();
  return (
    <Card className="icon-check-in-card">
      <Row className="card-row no-padding-row">
        <Col lg="9" xs="8">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <span className="mb-5px card-check-text">{title}</span>
            <span className="card-text-content"> {content}</span>
          </div>
        </Col>
        <Col
          lg="3"
          xs="4"
          style={{ marginRight: '0px', display: 'flex', justifyContent: 'flex-end' }}
        >
          {active ? (
            <Container
              onClick={() =>
                type === 'checkOut' && checkOutFunction
                  ? checkOutFunction()
                  : navigate(`/guest-registration/${reservationId}`, {
                      state: data || [],
                    })
              }
              className="checkin-icon-container"
            >
              {type === 'checkIn' ? (
                <BoxArrowInRight style={{ margin: 'auto' }} size={27} className="icon" />
              ) : (
                <BoxArrowInLeft style={{ margin: 'auto' }} size={27} className="icon" />
              )}
            </Container>
          ) : (
            renderLockIcon(type)
          )}
        </Col>
      </Row>
    </Card>
  );
};
